/**
 * @generated SignedSource<<7d0b343425f0b953a27a7ec9aa624db6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DemographicsSettingsQuery$variables = {};
export type DemographicsSettingsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSurveyDemographicInformationFragment_demographicProfileUrl">;
};
export type DemographicsSettingsQuery = {
  response: DemographicsSettingsQuery$data;
  variables: DemographicsSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DemographicsSettingsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "useSurveyDemographicInformationFragment_demographicProfileUrl"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DemographicsSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "demographicProfileUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endlessProfilerUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profilerUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileCompletion",
        "kind": "LinkedField",
        "name": "profileCompletionPercentage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "profileCompletionPercentage",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6df4167a6085da2067188ddeb49e28bc",
    "id": null,
    "metadata": {},
    "name": "DemographicsSettingsQuery",
    "operationKind": "query",
    "text": "query DemographicsSettingsQuery {\n  ...useSurveyDemographicInformationFragment_demographicProfileUrl\n}\n\nfragment useMoreSurveysBannerQuery_profileUrlRef on Query {\n  endlessProfilerUrl\n  demographicProfileUrl\n  profilerUrl\n  profileCompletionPercentage {\n    profileCompletionPercentage\n    id\n  }\n  userData {\n    firstName\n    id\n  }\n}\n\nfragment useSurveyDemographicInformationFragment_demographicProfileUrl on Query {\n  demographicProfileUrl\n  ...useMoreSurveysBannerQuery_profileUrlRef\n  profilerUrl\n}\n"
  }
};
})();

(node as any).hash = "b04fc2e6c8610b0ab831c7f1f9fa2667";

export default node;
